<template>
  <button
    class="navigation-toggler"
    :class="[{'hamburger--is-open': isOpen}, cssClasses]"
    :aria-label="tStatic('menu')"
    :aria-expanded="isOpen ? 'true' : 'false'"
    aria-controls="navigation-slide">
    <div class="hamburger">
      <span class="hamburger__row hamburger__row--1"></span>
      <span class="hamburger__row hamburger__row--2"></span>
      <span class="hamburger__row hamburger__row--3"></span>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style lang="scss">
.navigation-toggler {
  background-color: transparent;
  height: 1.375rem;
  border: none;
  padding: 0;
  margin: 0;

  &:hover {
    cursor: pointer;
  }
}

.hamburger {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 1.375rem;
  height: 1.375rem;
  vertical-align: middle;
}

.hamburger .hamburger__row {
  width: 100%;
  height: 4px;
  transition: all 0.18s cubic-bezier(0.645, 0.045, 0.355, 1.000);
  transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1.000);
  background-color: white;
}

.hamburger--is-open .hamburger__row--1 {
  transform: translateY(9px) translateX(0) rotate(45deg);
}

.hamburger--is-open .hamburger__row--2 {
  opacity: 0;
  transition: all 0s;
}

.hamburger--is-open .hamburger__row--3 {
  transform: translateY(-9px) translateX(0) rotate(-45deg);
}
</style>
